export const APP_ROUTES = {
  home: '/',
  login: '/login',
  register: '/register',
  profile: '/profile',
  leaderboard: '/leaderboard',
  chat: '/chat',
  notifications: '/notifications',
  exchangeDetail: '/exchange/:requestId',
  donationRequestDetail: '/donation-requests/:requestId',
  itemDetail: '/items/:itemId',
  admin: '/admin/*',
}
